export const WEIGHT_LOSS_LOCAL_STORAGE_KEY = "weight_loss_form_data";
export const FASTING_LOCAL_STORAGE_KEY = "fasting_form_data";
export const TRACKING_DEVICE_TOKEN_KEY = "tracking_device_token";
export const SKU_INFO = "sku_info";
export const SINUP_EMAIL = "sinup_email";
export const DISCOUNT_TIME = "discount_time";
export const RESULT_CLICK_LOGGED = "result_click_logged";
export const QUESTIONNAIRE_SUBMIT_LOGGED = "questionnaire_submit_logged";
export const PAY_REMAIN_SHOWN = "pay_remain_shown";
export const PAY_TIMER_START = "pay_timer_start";
export const HAS_SHOWN_SCRATCH_PRIZE = "has_shown_scratch_prize";
export const USER_INFO = "user_info";
export const COUNTRY_CODE = "country_code";
export const CURRENCY_CODE = "currency_code";
export const REFERRERS = "referrers";
export const MODE = "mode";
export const GCLID = "gclid";
export const MARKETING_EMAIL_ID = "marketing_email_id";
export const EMAIL_COUPON_CODE = "email_coupon_code";
export const FROM_EMAIL_DATE = "from_email_date";
export const FROM_EMAIL_71_DISCOUNT = "from_email_71_discount";
export const SURVEY_FROM = "survey_from";
export const GOOGLE_PARAMS = "google_params";
export const FACEBOOK_PARAMS = "facebook_params";
export const PINTEREST_PARAMS = "pinterest_params";
export const TIKTOK_PARAMS = "tiktok_params";
export const APPLOVIN_PARAMS = "applovin_params";
export const TWITTER_PARAMS = "twitter_params";
export const REDDIT_PARAMS = "reddit_params";
export const SNAPCHAT_PARAMS = "snapchat_params";
